<template lang="pug">
.el-container(id="DeviceList-container")
  .el-card.el-card-margin-4.el-card-full-width.el-card-full-height-with-scroll(v-if='loading')
    i.el-icon-loading
    span &nbsp; {{loadingStatus}}
  .el-card.el-card-margin-4.el-card-full-width.el-card-full-height-with-scroll(v-if='!loading', @click.self='selectNone($event); closeRightClickMenu()')
    el-header
      TagFilterDevices2(v-show='this.$store.state.Device.show_tag_filter', side="right")
      span.header-title-underlined
        el-input(id="DeviceList-searchInput", style="width:200px;", size="mini", v-model="searchString", clearable)
          i.el-icon-search.el-input__icon(slot='suffix')
      NaviButtons.float-right(:side="side", @reloadRightComponent='reloadRightComponent', @click='closeRightClickMenu')
      hr.header
    .pagination-row(id="DeviceList-paginationRow")
      el-pagination(
        @size-change='handlePaginationSizeChange',
        @current-change='handlePaginationCurrentChange',
        :current-page.sync='currentPaginationPage',
        :page-sizes='[10, 20, 50, 100]',
        :page-size.sync='currentPaginationSize',
        background,
        layout='prev, pager, next, total, sizes',
        :total='desktopsLength',
        @click='closeRightClickMenu'
      )
      .div.float-right.filter-status-icons
        el-button(id="DeviceList-sleepingFilter", type="text", @click='toggleFilterByStatusAlerted()',
          :class='{ "alerted-notice": localStatusDeviceFilters.includes("alerted-notice"), "alerted-warning": localStatusDeviceFilters.includes("alerted-warning"), "alerted-error": localStatusDeviceFilters.includes("alerted-error") }',
          :title='$t("Players with alerts")'
        ).icon
          font-awesome-icon(icon="exclamation-circle")
        el-button(id="DeviceList-sleepingFilter", type="text", @click='toggleFilterByStatus("sleep")',
          :class='{ active: localStatusDeviceFilters.includes("sleep") }',
          :title='$t("Sleeping players")'
        ).icon
          font-awesome-icon(icon="moon")
        el-button(id="DeviceList-deployedFilter", type="text", @click='toggleFilterByStatusDeployed()',
          :class='{ deployed: localStatusDeviceFilters.includes("deployed"), unDeployed: localStatusDeviceFilters.includes("unDeployed"), incativeDeployed: localStatusDeviceFilters.includes("invactiveDeployed") }',
          :title='$t("Deployed players")'
        ).icon
          font-awesome-icon(icon="industry")
        el-button(id="DeviceList-waitingContentApprovalFilter", type="text", @click='toggleFilterByStatus("uploading")',
          :class='{ active: localStatusDeviceFilters.includes("uploading") }',
          :title='$t("Players waiting for content approval")'
        ).icon
          font-awesome-icon(icon="upload")
        el-button(id="DeviceList-synchronizingContentFilter", type="text", @click='toggleFilterByStatus("syncing")',
          :class='{ active: localStatusDeviceFilters.includes("syncing") }',
          :title='$t("Players synchronizing content")'
        ).icon
          font-awesome-icon(icon="cloud-download-alt")
        el-button(id="DeviceList-heartbeatStatusFilter", type="text", @click='toggleFilterByStatusHB()',
          :class='{activeHB: localStatusDeviceFilters.includes("activeHB"), inactiveHB: localStatusDeviceFilters.includes("inactiveHB"), neveractiveHB: localStatusDeviceFilters.includes("neveractiveHB")}',
          :title='$t("Heartbeat status")'
        ).icon
          font-awesome-icon(icon="medkit")
    .desktops-container
      .desktop-row(
        v-for="desktop in this.$store.state.Device.desktops_cache",
        :id="'DeviceList-desktopRow'+desktop.id",
        :key="desktop.id",
        :class='{ selected: desktopIsSelected(desktop), hovered: desktopIsHovered(desktop), dead: !desktop.alive, inactive: desktop.HBTimestamp == "0" }',
        @click='toggleDesktopSelected(desktop, $event, desktops);',
        @dblclick='loadEditMediumInMediaEditor(desktop, $event)',
        @dragenter='dragEnterDesktop(desktop, $event)',
        @dragend="dragEnd(desktop, $event)",
        @contextmenu='openRightClickMenu(desktop, $event)',
        @mouseenter="mouseOverDesktop(desktop)",
        @mouseleave="mouseOverDesktop(null)"
      )
        .cell.thumbnail
          .screenshot(
            :id="'DeviceList-desktopThumbnail'+desktop.id",
            :style="getScreenShotStyle(desktop.id)",
            @click.stop=' closeRightClickMenu(); showScreenShot(desktop)',
            :title="desktop.deviceDesktopScreenShotFilename ? $t('Screenshot') : $t('No screenshot yet')"
          )
          .info-icon(v-if='getExtraHBData(desktop).standby')
            font-awesome-icon(icon="moon")
          .info-icon(
            v-if='hasAlerts(desktop)',
            :class='getAlertClassForDesktop(desktop)',
          )
            font-awesome-icon(icon="exclamation-circle")
        .cell.cogs(:title="$t('Edit device')", :id="'DeviceList-desktopEditButton'+desktop.id")
          font-awesome-icon(@dblclick.stop="editDevice(desktop, 'heartbeat')", icon="cog")
          br
          font-awesome-icon(@dblclick.stop="editDevice(desktop, 'schedule')", v-if='desktopHasSchedule(desktop)', icon="clock")
        .cell.name(:class='{"test-device": desktop.Device.test}')
          span {{ getFullDeviceNameByDesktopId(desktop.id) }}
          //- span(v-if='desktop.name.length > 0 && desktop.name !== "single"') &nbsp;-&nbsp;{{ desktop.name }}
          .small.muted
            .line {{ getDeviceFromDesktop(desktop).description }}
            .line {{ getGroupFromDesktop(desktop) ? getGroupFromDesktop(desktop).name : '' }}
            .line(v-if='isSuperAdmin') {{ desktop.uuid }}
          span.playlist {{ __formatLocalPlaylistContent(desktop.LocalPlayList) }}
        .cell.tags
          DeviceTagsShortInfo(:deviceId='desktop.Device', @editDevice='editDevice(desktop)')
          //- cannot display restrictions without populating (and it is performance overkill at app start)
          //- .playitem-restriction-line
          //-   ScheduleDateList(:restrictions='getDeviceFromDesktop(desktop).DeviceDesktop_DateRestrictions')
          //-   ScheduleDayTimeList(:restrictions='getDeviceFromDesktop(desktop).DeviceDesktop_DaytimeRestrictions', dayLabelLength='shortest')
        .cell.status-icons
          span(v-if='updatingDesktopsInLiveMode')
            font-awesome-icon.icon.icon-hourglass.muted(icon="hourglass")
          span(v-if='!updatingDesktopsInLiveMode')
            .no-wrap.cursor-pointer(
              v-if='modificationExists(desktop)',
              @dblclick.stop="sendContentUpdateRequest(desktop, $event)",
              :id="'DeviceList-sendContentUpdateRequestButton'+desktop.id",
              :title="$t('Send content update to screen')",
              :class='{ muted: desktop.HBTimestamp == "0" }'
            )
              font-awesome-icon.icon(icon="upload") &nbsp;
              span.no-wrap(v-if='currentTime') &nbsp; {{ humanDuration(currentTime - modificationTime(desktop), 'rounded') }}
            .no-wrap(
              :title="`${humanTime(parseInt(contentDownload(desktop).updatedAt))} ${contentDownload(desktop).failedMessage}`",
              v-if='contentDownload(desktop) && contentDownload(desktop).progress < 100',
              :class='{ muted: desktop.HBTimestamp == "0", danger: contentDownload(desktop).failed }'
            )
              font-awesome-icon.icon(icon="cloud-download-alt")
              span.no-wrap &nbsp; {{ Math.round(contentDownload(desktop).progress) }}%
      //- stupid refresh DOM workaround
      span.float-right(style="opacity: 0.01;") {{ desktops.length }}
      el-dialog(:close-on-click-modal="false", title='', :visible.sync='editDeviceVisible', @close='closeEditDevice()', append-to-body, width='70%')
        EditDevice(ref='EditDevice', v-if='editedDevice', :editedDeviceId='editedDevice.id')
      el-dialog(:close-on-click-modal="false", title='', :visible.sync='showScreenShotVisible', @close='showScreenShotVisible = false; screenshot = { url:"", desktop: undefined }', append-to-body, width='80%')
        p(v-if='showScreenShotVisible')
          span {{ screenshot.desktop.Device.name ? screenshot.desktop.Device.name : screenshot.deviceName }}
          span(v-if='screenshot.desktop.name.length > 0 && screenshot.desktop.name !== "single"') &nbsp;-&nbsp;{{ screenshot.desktop.name }}
          span &nbsp;-&nbsp;{{ humanTime(parseInt(screenshot.desktop.deviceDesktopScreenShotTimestamp)) }}
          span.muted &nbsp; ({{ humanDuration(currentTime - parseInt(screenshot.desktop.deviceDesktopScreenShotTimestamp)) }} {{$t('ago')}})
        img.sshot(:src='screenshot.url',  :style='{ opacity: waitingForBigScreenShot ? "0.2" : "1.0" }')
        p
          el-button(id="DeviceList-refreshScreenshotButton" @click='updateScreenShotFull(screenshot.desktop)', type='success', size='mini', :disabled='waitingForBigScreenShot')
            font-awesome-icon(icon="sync")
            span &nbsp; {{ $t('Refresh with big screenshot') }}

  RightClickDesktopMenu(ref='RightClickDesktopMenu', @rightClickAction='rightClickAction')
  ConfirmDialog(
    v-if='confirmDialogVisible',
    :confirmDialogVisible='confirmDialogVisible',
    :question='confirmDialogQuestion',
    :data='rightClickData',
    @confirmed='dialogConfirmed',
    @closed='dialogDenied',
    :percentDone='confirmDialogpercentDone',
  )
</template>

<script>
import Vue from 'vue'
import NaviButtons from './NaviButtons'
import EditDevice from './AddEditDevice'
import DeviceTagsShortInfo from './DeviceTagsShortInfo'
import mediaUtils from '../Common/mediaUtils.mixin'
import deviceUtils from '../Common/deviceUtils.mixin'
import deviceRCLCK from '../Common/deviceRCLCK.mixin'
import textUtils from '../Common/textUtils.mixin'
import userUtils from '../Common/userUtils.mixin'
import ScheduleDateList from '../Common/ScheduleDateList'
import ScheduleDayTimeList from '../Common/ScheduleDayTimeList'
import TagFilterDevices2 from './TagFilterDevices2'
import RightClickDesktopMenu from './RightClickDesktopMenu'
import ConfirmDialog from '../Common/ConfirmDialog'

export default {
  mixins: [textUtils, mediaUtils, deviceUtils, deviceRCLCK, userUtils],
  components: {
    NaviButtons,
    EditDevice,
    DeviceTagsShortInfo,
    TagFilterDevices2,
    RightClickDesktopMenu,
    ScheduleDateList,
    ScheduleDayTimeList,
    ConfirmDialog
  },
  props: ['side'],
  data () {
    return {
      errors: {
      },
      loading: false,
      loadingStatus: this.$t('Preparing Players...'),
      showMode: 'desktops',
      currentPaginationPage: 1,
      currentPaginationSize: 10,
      desktopsLength: undefined,
      updateTimeIntervalPointer: null,
      updateDesktopsTimeoutPointer: null,
      updatingDesktopsInLiveMode: false,
      currentTime: Date.now(),
      hbExpectedIntervalMs: 1000 * 60,
      localStatusDeviceFilters: this.$store.state.Device.localStatusDeviceFilters[this.side],
      localPlaylistsCache: [],
      liveMode: true,
      screenshot: {
        url: '',
        desktop: undefined
      },
      showScreenShotVisible: false,
      hoveredDesktop: null,
      waitingForBigScreenShot: false
    }
  },
  async created () {
    await this.reloadLocalPlaylistsCache()
    Vue.$io.socket.post('/deviceDesktop/subscribeToDesktops', {
      ids: this.$store.state.Device.desktops_cache.map(dt => dt.id)
    })
    Vue.$io.socket.off('devicedesktop')
    Vue.$io.socket.on('devicedesktop', payload => {
      if (!this.$store.state.User.liveMode.heartbeat) return
      this.$store.dispatch('Device/updateDesktop', payload.hb)
    })
    Vue.$io.socket.off('screenshot_collected')
    Vue.$io.socket.on('screenshot_collected', desktop => {
      if (
        !this.$store.state.User.liveMode.screenshots &&
        // && is not our request
        this.desktopsScreenShotsRequested.find(d => d.id === desktop.id).length === 0
      ) {
        return
      }
      this.$store.dispatch('Device/updateDesktop', desktop)
      const indexToBeRomoved = this.desktopsScreenShotsRequested.findIndex(dsr => dsr.id === desktop.id)
      if (indexToBeRomoved > -1) {
        this.desktopsScreenShotsRequested.splice(indexToBeRomoved, 1)
      }
      if (!this.screenshot.desktop) return
      const openScreenShotForDeviceDesktop = this.$store.state.Device.desktop_list.find(dd => dd.id === this.screenshot.desktop.id)
      if (openScreenShotForDeviceDesktop) {
        this.screenshot.url = openScreenShotForDeviceDesktop.deviceDesktopScreenShotFilename
        this.screenshot.desktop = openScreenShotForDeviceDesktop
        // this.screenshot.deviceName = device.name
        this.screenshot.deviceName = this.getFullDeviceNameByDesktopId(desktop.id)
        this.waitingForBigScreenShot = false
      }
    })
    clearInterval(this.updateTimeIntervalPointer)
    this.updateTimeIntervalPointer = setInterval(() => {
      this.currentTime = Date.now()
    }, 1000)
  },
  beforeDestroy () {
    Vue.$io.socket.post('/deviceDesktop/unsubscribeFromDesktops', {
      ids: this.$store.state.Device.desktops_cache.map(dt => dt.id)
    })
  },
  watch: {
    desktops: async function (newVal, oldVal) {
      const desktopsIds = newVal.map(dt => dt.id)
      const desktopsIdsOld = oldVal.map(dt => dt.id)
      if ((JSON.stringify(desktopsIds.sort()) === JSON.stringify(desktopsIdsOld.sort())) || desktopsIds.length === 0) {
        return
      }
      // !!! Cannot reset page to 1 here: watch desktops is triggered also with pagination change !!!
      this.updatingDesktopsInLiveMode = true
      const desktops = (await Vue.axios
        .get(`/devicedesktop?where={"id":{"in":${JSON.stringify(desktopsIds)}}}&populate=LocalPlayList`)).data
      this.$store.dispatch('Device/updateDesktopHB', desktops)
      this.localPlaylistsCache = (await Vue.axios
        .get(`/medium?where={"id":{"in":${JSON.stringify(desktops.map(d => d.LocalPlayList.id))}}}&populate=PlayListItems`)).data
      this.updatingDesktopsInLiveMode = false
      // If filters active - unsubscribe from desktops (freeze them)
      if (this.localStatusDeviceFilters.length > 0) {
        Vue.$io.socket.post('/deviceDesktop/subscribeToDesktops', {
          ids: []
        })
      } else {
        Vue.$io.socket.post('/deviceDesktop/subscribeToDesktops', {
          ids: desktopsIds
        })
      }
    },
    localPlaylistsCache: async function (newVal, oldVal) {
      this.$store.dispatch('Medium/setLocalPlaylistsCache', this.localPlaylistsCache)
    }
  },
  methods: {
    getAlertClassForDesktop (desktop) {
      if (this.desktopHasAlerts(desktop, 'error')) {
        return 'error'
      }
      if (this.desktopHasAlerts(desktop, 'warning')) {
        return 'warning'
      }
      if (this.desktopHasAlerts(desktop, 'notice')) {
        return 'notice'
      }
    },
    desktopHasAlerts (desktop, level) {
      return this.getExtraHBData(desktop).alerts.find(a => a.level === level)
    },
    async reloadLocalPlaylistsCache () {
      this.localPlaylistsCache = (await Vue.axios
        .get(`/medium?where={"id":{"in":${JSON.stringify(this.$store.state.Device.desktops_cache.map(d => d.LocalPlayList))}}}&populate=PlayListItems`)).data
    },
    __formatLocalPlaylistContent (id) {
      const playlist = this.localPlaylistsCache.find(medium => medium.id === id)
      if (!playlist || !playlist.PlayListItems || playlist.PlayListItems.length === 0) return ''
      const playlistFirstMediumId = JSON.parse(JSON.stringify(playlist.PlayListItems)).sort((a, b) => a.order - b.order)[0].Medium
      const playlistFirstMedium = this.$store.state.Medium.media_list.find(medium => medium.id === playlistFirstMediumId)
      if (playlistFirstMedium) {
        return playlist.PlayListItems.length === 1 ? playlistFirstMedium.name : playlistFirstMedium.name + '...'
      }
      return ''
    },
    getExtraHBData (desktop) {
      try {
        return JSON.parse(desktop.extraHB)
      } catch (e) {
        return []
      }
    },
    hasAlerts (desktop, severity = null) {
      const extraHBDataAlerts = this.getExtraHBData(desktop).alerts
      if (!extraHBDataAlerts) {
        return false
      } else {
        if (!severity) {
          return extraHBDataAlerts.find(a => a.level === 'error' || a.level === 'warning' || a.level === 'notice')
        } else {
          return extraHBDataAlerts.find(a => a.level === severity)
        }
      }
    },
    async updateScreenShotFull (desktop) {
      this.waitingForBigScreenShot = true
      await this.updateScreenshotSendRequestToDevice(desktop, 'full')
    },
    desktopIsHovered (desktop) {
      return this.hoveredDesktop && (this.hoveredDesktop.id === desktop.id)
    },
    mouseOverDesktop (desktop) {
      this.hoveredDesktop = desktop
    },
    showScreenShot (desktop) {
      this.screenshot.url = desktop.deviceDesktopScreenShotFilename ? desktop.deviceDesktopScreenShotFilename : this.playListThumbnailById(desktop.LocalPlayList)
      this.screenshot.desktop = desktop
      this.screenshot.deviceName = this.getFullDeviceNameByDesktopId(desktop.id)
      this.showScreenShotVisible = true
    },
    toggleFilterByStatus (status) {
      this.$store.commit('Device/TOGGLE_FILTER_BY_STATUS', { side: this.side, status })
    },
    toggleFilterByStatusHB () {
      this.$store.commit('Device/TOGGLE_FILTER_BY_STATUS_HB', { side: this.side })
    },
    toggleFilterByStatusDeployed () {
      this.$store.commit('Device/TOGGLE_FILTER_BY_STATUS_DEPLOYED', { side: this.side })
    },
    toggleFilterByStatusAlerted () {
      this.$store.commit('Device/TOGGLE_FILTER_BY_STATUS_ALERTED', { side: this.side })
    },
    async reloadData () {
      await this.$store.dispatch('Device/clearList')
      this.currentPaginationPage = this.$store.state.Device.pagination[this.side].page
      this.currentPaginationSize = this.$store.state.Device.pagination[this.side].limit
      if (this.$store.state.Device.device_list.length < 1) {
        await this.$store.dispatch('Device/loadData')
        // console.log('LET`S TRY NOT TO CLEAR MEDIA in device/list. May induce bugs, but allows drag-and-drop on newly created playlist... ')
        // this.$store.dispatch('Medium/clearMediaSelectedRight')
      }
    },
    modificationTime (desktop) {
      return this.$store.state.Device.desktops_affected.find(da => da.Medium.id === desktop.LocalPlayList).updatedAt
    },
    selectAll () {
      this.$store.dispatch('Device/addDesktopsSelectedRight', JSON.parse(JSON.stringify(this.$store.state.Device.desktops_cache)))
    },
    selectNone ($event) {
      if ($event.ctrlKey || $event.metaKey) return
      this.$store.dispatch('Device/clearDesktopsSelectedRight')
    },
    showHBdata (desktop) {
      const HBkeys = Object.keys(desktop).filter(key => key.indexOf('HB') > -1)
      const result = {}
      for (const HBkey of HBkeys) {
        result[HBkey] = desktop[HBkey]
      }
      if (result.extraHB === '{}') delete result.extraHB
      return result
    },
    async updateScreenshotSendRequestToDevice (desktop, type = 'small') {
      this.desktopsScreenShotsRequested.push(desktop)
      await Vue.axios
        .post('/deviceDesktop/updateScreenshotSendRequestToDevice', {
          desktopId: desktop.id,
          type
        })
    },
    getScreenShotStyle (desktopId) {
      const desktop = this.$store.state.Device.desktops_cache.find(dt => dt.id === desktopId)
      if (!desktop) return ''
      const sshotFile = desktop.deviceDesktopScreenShotFilename ? desktop.deviceDesktopScreenShotFilename : ''
      const reguestSshotStyle = this.desktopsScreenShotsRequested.find(dt => dt.id === desktopId) ? 'opacity: 0.2;' : ''
      const style = `
          width: ${desktop.width / 17}px;
          height: ${desktop.height / 17}px;
          ${reguestSshotStyle}
      `
      if (sshotFile && sshotFile.length > 0) {
        return `
          background-image: url('${desktop.name !== 'headless' ? sshotFile : 'static/audio.svg'}');
          background-size: contain;
          background-repeat: no-repeat;
          ${style}
          `
      } else {
        return `
          background-image: url('static/none2.png');
          ${style}
          `
      }
    },
    // FIXME DRY
    loadEditMediumInMediaEditor (desktop, $event) {
      if ($event && ($event.ctrlKey || $event.metaKey)) {
        this.toggleDesktopSelected(desktop, $event)
        return
      }
      const medium = this.localPlaylistsCache.find(
        medium => medium.id === desktop.LocalPlayList
      )
      if (!medium) return
      this.$store.commit('Medium/ADD_TO_MEDIALIST', medium)
      this.$emit('loadEditMediumInMediaEditor', medium)
      this.$store.dispatch('Medium/clearBreadcrumbs')
      this.$store.dispatch('Medium/addMediumIdToBreadcrumbs', medium.id)
    },
    /** PAGINATION */
    handlePaginationSizeChange (val) {
      this.currentPaginationSize = val
      this.$store.dispatch('Device/paginationSetLimit', [this.side, val])
    },
    handlePaginationCurrentChange (val) {
      this.currentPaginationPage = val
      this.$store.dispatch('Device/paginationSetPage', [this.side, val])
    },
    __filterDesktops () {
      let desktops = this.$store.state.Device.desktop_list
      const devicesFilteredIds = this.__filterDevicesByTags(this.$store.state.Device.device_list).map(d => d.id)
      desktops = desktops
        .filter(desktop => devicesFilteredIds.includes(desktop.Device))
      if (this.localStatusDeviceFilters.includes('inactiveHB')) {
        desktops = desktops
          .filter(desktop => !desktop.alive)
      }
      if (this.localStatusDeviceFilters.includes('activeHB')) {
        desktops = desktops
          .filter(desktop => desktop.alive && !(parseInt(desktop.HBTimestamp, 10) === 0))
      }
      if (this.localStatusDeviceFilters.includes('neveractiveHB')) {
        desktops = desktops
          .filter(desktop => parseInt(desktop.HBTimestamp, 10) === 0)
      }
      if (this.localStatusDeviceFilters.includes('syncing')) {
        const downloadingDesktopsIds = this.$store.state.Device.content_downloads
          .filter(cd => cd.progress < 100)
          .map(cd => cd.ContentDownloadDeviceDesktop)
        desktops = desktops
          .filter(desktop => downloadingDesktopsIds.includes(desktop.id))
      }
      if (this.localStatusDeviceFilters.includes('deployed')) {
        desktops = desktops
          .filter(desktop => this.getDeviceFromDesktop(desktop).active)
      }
      if (this.localStatusDeviceFilters.includes('unDeployed')) {
        desktops = desktops
          .filter(desktop => !this.getDeviceFromDesktop(desktop).active)
      }
      if (this.localStatusDeviceFilters.includes('sleep')) {
        desktops = desktops
          .filter(desktop => this.getExtraHBData(desktop).standby)
      }
      if (this.localStatusDeviceFilters.includes('alerted-notice')) {
        desktops = desktops
          .filter(desktop => this.hasAlerts(desktop, 'notice'))
      }
      if (this.localStatusDeviceFilters.includes('alerted-warning')) {
        desktops = desktops
          .filter(desktop => this.hasAlerts(desktop, 'warning'))
      }
      if (this.localStatusDeviceFilters.includes('alerted-error')) {
        desktops = desktops
          .filter(desktop => this.hasAlerts(desktop, 'error'))
      }
      if (this.localStatusDeviceFilters.includes('uploading')) {
        desktops = desktops
          .filter(desktop => this.modificationExists(desktop))
      }

      const searchString = this.$store.state.Device.search_by_string.toLowerCase()
      if (this.$store.state.Device.search_by_string.length > 1) {
        desktops = desktops
          .filter(desktop => desktop.concatedname.toLowerCase().indexOf(searchString) > -1)
      }
      if (this.desktopsLength && (this.desktopsLength !== desktops.length)) {
        // TODO. Perhaps sometimes different desktops will have same length?
        this.handlePaginationCurrentChange(1)
      }
      this.desktopsLength = desktops.length
      const offset =
        (this.$store.state.Device.pagination[this.side].page - 1) *
        this.$store.state.Device.pagination[this.side].limit
      const result = desktops.slice(
        offset,
        offset + this.$store.state.Device.pagination[this.side].limit
      )
      this.$store.dispatch('Device/setDesktopListCache', JSON.parse(JSON.stringify(result)))
      return result
    },
    __filterDevicesByTags (devices) {
      let sideFilter = this.$store.state.Device.device_filter[this.side]
      if (sideFilter.deviceTags.length > 0) {
        if (!sideFilter.deviceTagsAll) {
          let unionOfDeviceIds = []
          for (let index = 0; index < sideFilter.deviceTags.length; index++) {
            unionOfDeviceIds = [
              ...new Set([
                ...unionOfDeviceIds,
                ...sideFilter.deviceTags[index].device
              ])
            ]
          }
          devices = devices.filter(device =>
            unionOfDeviceIds.includes(device.id)
          )
        } else {
          for (let index = 0; index < sideFilter.deviceTags.length; index++) {
            devices = devices.filter(device =>
              sideFilter.deviceTags[index].device.includes(device.id)
            )
          }
        }
      }
      return devices
    },
    reloadRightComponent () {
      this.$emit('reloadRightComponent')
    },
    contentDownload (desktop) {
      if (!desktop) return
      const desktopDownloads = this.$store.state.Device.content_downloads
        .filter(cd => cd.ContentDownloadDeviceDesktop === desktop.id)
      return desktopDownloads[desktopDownloads.length - 1]
    }
  },
  computed: {
    deviceTagFilterHidden () {
      return !this.$store.state.Device.show_tag_filter
    },
    desktopsSelectedRight () {
      return this.$store.state.Device.desktops_selected_right
    },
    desktopsSelectedLeft () {
      return this.$store.state.Device.desktops_selected_left
    },
    desktops () {
      return this.__filterDesktops()
    },
    searchString: {
      get () {
        return this.$store.state.Device.search_by_string
      },
      set (value) {
        // this.$store.dispatch('Device/paginationSetPage', [ this.side, 1 ])
        this.$store.commit('Device/UPDATE_SEARCH_STRING', value)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.header-title-underlined {
  .tag-filter-icon {
    margin-left: 5px;
    &.active-filter-tags {
      color: $--color-warning;
    }
  }
}
.pagination-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: $--page-background;
  position: sticky;
  top: -5px;
  z-index: 1;
  .filter-status-icons {
    cursor: pointer;
    .icon {
      font-size: 12px;
      color: $--color-text-secondary;
      padding: 0px;
      margin: 0px 5px 0px 0px;
      &.active {
        color: $--color-text-primary;
      }
      &.activeHB, &.deployed {
        color: green;
      }
      &.inactiveHB, &.alerted-error {
        color: $--color-danger;
      }
      &.neveractiveHB, &.unDeployed, &.alerted-notice {
        color: $--color-success;
      }
      &.alerted-warning  {
        color: $--color-warning;
      }
    }
  }
}
.desktops-container {
  margin-top: 16px;
  border-top: $--border-light;
  padding-bottom: 50px;
  .desktop-row {
    display: flex;
    border-bottom: $--border-light;
    align-items: center;
    // justify-content: space-between;
    padding: 3px 0px 3px 5px;
    cursor: default;
    &.hovered {
      .cell {
        &.cogs {
          opacity: 1;
        }
      }
    }
    &.selected {
      background-color: $--background-color-selected;
      box-shadow: inset 0 0 5px green;
      &.dead {
        box-shadow: inset 0 0 5px $--color-danger;
        background-color: rgba(mix($--background-color-selected, $--color-danger, 94%), 0.6);
      }
      &.inactive {
        box-shadow: inset 0 0 5px $--color-success;
        background-color: rgba(mix($--background-color-selected, $--color-success, 94%), 0.6);
      }
    }
    &.overdueHB {
      .status-icons {
        color: $--color-danger;
      }
    }
    &.dead {
      background-color: rgba($--color-danger, 0.2);
    }
    &.inactive {
      background-color: rgba($--color-success, 0.2);
    }
    .cell {
      overflow: hidden;
      border: 0px dotted red;
      &.thumbnail {
        width: 14%;
        // padding-left: 14px;
        position: relative;
        .screenshot {
          border: 1px solid #999;
          position: relative;
          background-position: center center;
          background-size: cover;
          cursor: zoom-in;
        }
        .info-icon {
          position: absolute;
          bottom: 2px;
          left: 2px;
          padding: 0px 2px;
          color: $--color-warning;
          &.error {
            color: $--color-danger;
          }
          &.warning {
            color: $--color-warning;
          }
          &.notice {
            color: $--color-success;
          }
        }
      }
      &.cogs {
        width: 3%;
        opacity: 0;
        color: $--color-text-secondary;
        cursor: pointer;
      }
      &.name {
        // margin-left: 10px;
        line-height: 13px;
        width: 40%;
        span {
          font-size: $--font-size-base;
        }
        .playlist {
          font-size: $--font-size-base;
          color: $--color-warning;
          border: 0px dotted violet;
          margin: 0px 0px 0px 0px;
        }
        &.test-device {
          color: $--color-text-regular-green;
        }
      }
      &.tags {
        max-height: 80px;
        width: 36%;
        padding: 0px;
        overflow: hidden;
      }
      &.status-icons {
        width: 7%;
        padding: 0px 0px 0px 0px;
        display:flex;
        flex-direction: column;
        font-size: $--font-size-base;
        .icon {
          width: 12px;
        }
      }
    }
  }
}

@keyframes hbanimation {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  25% {
    opacity: 0.5;
    transform: scale(0.5);
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
  75% {
    opacity: 0.5;
    transform: scale(0.5);
  }
  100% {
    opacity: 0;
    transform: scale(0);
  }
}
.sshot {
  max-width: 100%;
  border: 1px solid $--color-primary;
}
</style>



// WEBPACK FOOTER //
// src/components/Device/List.vue